import type { UserSystemUsage } from './user';

export const DASHBOARD_STATUSES = {
    GREEN: 'GREEN',
    ORANGE: 'ORANGE',
    RED: 'RED',
} as const;

export type DashboardStatus = (typeof DASHBOARD_STATUSES)[keyof typeof DASHBOARD_STATUSES];

export const DASHBOARD_STATUSES_ORDER = [
    DASHBOARD_STATUSES.GREEN,
    DASHBOARD_STATUSES.ORANGE,
    DASHBOARD_STATUSES.RED,
] as const;

export type DashboardUserSystemUsage = Extract<UserSystemUsage, '1st_line' | '2nd_line' | 'oversight'>;
